"use client";

import { useRouter, usePathname } from "next/navigation";
import { Sliders } from "react-feather";
import classes from "./CategoriesDiscover.module.css";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import CategoriesContentText from "./CategoriesContentText";
import brands from "@/utils/brands";
import Image from "next/image";
import algoliasearch from "algoliasearch";

const client =
  process.env.NEXT_PUBLIC_OG_DB === "true"
    ? algoliasearch(
        process.env.NEXT_PUBLIC_ALGOLIA_APPID,
        process.env.NEXT_PUBLIC_ALGOLIA_API_KEY
      )
    : algoliasearch(
        process.env.NEXT_PUBLIC_DUMMY_ALGOLIA_APPID,
        process.env.NEXT_PUBLIC_DUMMY_ALGOLIA_API_KEY
      );

const CategoriesDiscover = (props) => {
  const {
    option,
    category,
    subType,
    brand,
    handleShow,
    locationCity,
    style,
    room,
    searchTerm,
    sortCriteria,
    uniqueBrandList,
  } = props;

  const pathname = usePathname();
  const router = useRouter();

  const locationParam =
    pathname.split("/").at(1) === "location" && pathname.split("/").at(2);
  const roomParam =
    pathname.split("/").at(1) === "room" && pathname.split("/").at(2);
  const styleParam =
    pathname.split("/").at(1) === "style" && pathname.split("/").at(2);
  const brandParam =
    pathname.split("/").at(1) === "brand" && pathname.split("/").at(2);

  let subParams = {
    styleParam,
    roomParam,
    locationParam,
    brandParam,
    searchTerm,
    styleBubbles: pathname.includes("/style"),
    roomBubbles: pathname.includes("/room"),
    brandBubbles: pathname.includes("/brand"),
  };

  const [showStyles, setShowStyles] = useState(false);

  const [loading, setLoading] = useState(false);
  const [displayListings, setDisplayListings] = useState([]);
  const [extraTwoListings, setExtraTwoListings] = useState([]);

  console.log(displayListings);

  const getListingsHandler = async (
    category,
    subcategory,
    type,
    brand,
    limit
  ) => {
    let beforeSearch = window.location.search;

    setLoading(true);

    const index = client.initIndex(`kashew_listings`);
    await index
      .search("", {
        hitsPerPage: 4000,
        clickAnalytics: true,
        page: 0,
        filters: `status:active ${
          locationCity ? ` AND region:"${locationCity}"` : ""
        }${
          category
            ? ` AND newSchema.categories:"${category
                .replace(/-/g, " ")
                .replace(/\band\b/g, "&")}"`
            : ""
        }${
          subcategory
            ? ` AND newSchema.subCategories:"${subcategory
                .replace(/-/g, " ")
                .replace(/\band\b/g, "&")}"`
            : ""
        }${
          type
            ? ` AND newSchema.types:"${type
                .replace(/-/g, " ")
                .replace(/\band\b/g, "&")}"`
            : ""
        }${
          brand
            ? ` AND newBrand:"${brand
                .replace(/-/g, " ")
                .replace(/\band\b/g, "&")}"`
            : ""
        }`,
      })
      .then(async (res) => {
        let listings = [];
        setShowStyles(false);

        if (!category && !subcategory && !type) {
          // Count frequency of each category
          const categoryCounts = {};
          for (let i of res.hits) {
            const cat = i.newSchema.categories?.[0];
            if (cat && i.newSchema.categories?.length === 1) {
              categoryCounts[cat] = (categoryCounts[cat] || 0) + 1;
            }
          }
          // Sort categories by frequency
          const sortedCategories = Object.entries(categoryCounts)
            .sort((a, b) => b[1] - a[1])
            .map(([cat]) => cat)
            .slice(0, limit);
          // For each category, pick the item with highest relevance
          for (let cat of sortedCategories) {
            const groupItems = res.hits.filter(
              (i) =>
                i.newSchema.categories?.[0] === cat &&
                i.newSchema.categories?.length === 1
            );
            const item = groupItems.reduce(
              (max, curr) =>
                curr.relevance > (max?.relevance ?? -Infinity) ? curr : max,
              null
            );
            if (item) {
              listings.push({
                ...item,
                velouAttributes: {
                  style:
                    item?.velouAttributes?.styles?.length > 0
                      ? item?.velouAttributes?.styles[0]
                      : "",
                },
              });
            }
          }
        } else if (category && !subcategory && !type) {
          // Count frequency of each subcategory
          const subcategoryCounts = {};
          for (let i of res.hits) {
            const subcat = i.newSchema.subCategories?.[0];
            if (
              subcat &&
              i.newSchema.categories?.length === 1 &&
              i.newSchema.subCategories?.length === 1
            ) {
              subcategoryCounts[subcat] = (subcategoryCounts[subcat] || 0) + 1;
            }
          }
          // Sort subcategories by frequency
          const sortedSubcategories = Object.entries(subcategoryCounts)
            .sort((a, b) => b[1] - a[1])
            .map(([subcat]) => subcat)
            .slice(0, limit);
          // For each subcategory, pick the item with highest relevance
          for (let subcat of sortedSubcategories) {
            const groupItems = res.hits.filter(
              (i) =>
                i.newSchema.subCategories?.[0] === subcat &&
                i.newSchema.categories?.length === 1 &&
                i.newSchema.subCategories?.length === 1
            );
            const item = groupItems.reduce(
              (max, curr) =>
                curr.relevance > (max?.relevance ?? -Infinity) ? curr : max,
              null
            );
            if (item) {
              listings.push({
                ...item,
                velouAttributes: {
                  style:
                    item?.velouAttributes?.styles?.length > 0
                      ? item?.velouAttributes?.styles[0]
                      : "",
                },
              });
            }
          }
        } else if (category && subcategory && !type) {
          // Count frequency of each type
          const typeCounts = {};
          for (let i of res.hits) {
            const typ = i.newSchema.types?.[0];
            if (
              typ &&
              i.newSchema.categories?.length === 1 &&
              i.newSchema.subCategories?.length === 1 &&
              i.newSchema.types?.length === 1 &&
              !i.newSchema.types.includes("None")
            ) {
              typeCounts[typ] = (typeCounts[typ] || 0) + 1;
            }
          }
          // Sort types by frequency
          const sortedTypes = Object.entries(typeCounts)
            .sort((a, b) => b[1] - a[1])
            .map(([typ]) => typ)
            .slice(0, limit);
          // For each type, pick the item with highest relevance
          for (let typ of sortedTypes) {
            const groupItems = res.hits.filter(
              (i) =>
                i.newSchema.types?.[0] === typ &&
                i.newSchema.categories?.length === 1 &&
                i.newSchema.subCategories?.length === 1 &&
                i.newSchema.types?.length === 1 &&
                !i.newSchema.types.includes("None")
            );
            const item = groupItems.reduce(
              (max, curr) =>
                curr.relevance > (max?.relevance ?? -Infinity) ? curr : max,
              null
            );
            if (item) {
              listings.push({
                ...item,
                velouAttributes: {
                  style:
                    item?.velouAttributes?.styles?.length > 0
                      ? item?.velouAttributes?.styles[0]
                      : "",
                },
              });
            }
          }

          if (listings.length === 0) {
            listings = [];
            await index
              .search("", {
                hitsPerPage: 10000,
                clickAnalytics: true,
                page: 0,
                filters: `status:active${
                  category
                    ? ` AND newSchema.categories:"${category
                        .replace(/-/g, " ")
                        .replace(/\band\b/g, "&")}"`
                    : ""
                }${
                  subcategory
                    ? ` AND newSchema.subCategories:"${subcategory
                        .replace(/-/g, " ")
                        .replace(/\band\b/g, "&")}"`
                    : ""
                }`,
              })
              .then(async (res) => {
                // Count frequency of each style
                const styleCounts = {};
                for (let i of res.hits) {
                  const style = i?.velouAttributes?.styles?.[0];
                  if (
                    style &&
                    i.newSchema.subCategories?.length === 1 &&
                    i.newSchema.types?.length < 2 &&
                    !i.newSchema.types.includes("None")
                  ) {
                    styleCounts[style] = (styleCounts[style] || 0) + 1;
                  }
                }
                // Sort styles by frequency
                const sortedStyles = Object.entries(styleCounts)
                  .sort((a, b) => b[1] - a[1])
                  .map(([style]) => style)
                  .slice(0, limit);
                // For each style, pick the item with highest relevance
                for (let style of sortedStyles) {
                  const groupItems = res.hits.filter(
                    (i) =>
                      i?.velouAttributes?.styles?.[0] === style &&
                      i.newSchema.subCategories?.length === 1 &&
                      i.newSchema.types?.length < 2 &&
                      !i.newSchema.types.includes("None")
                  );
                  const item = groupItems.reduce(
                    (max, curr) =>
                      curr.relevance > (max?.relevance ?? -Infinity)
                        ? curr
                        : max,
                    null
                  );
                  if (item) {
                    listings.push({
                      ...item,
                      velouAttributes: {
                        style: style,
                      },
                    });
                  }
                }
              })
              .catch((err) => console.log(err));
            setShowStyles(true);
          }
        } else if (category && subcategory && type) {
          // Count frequency of each style
          const styleCounts = {};
          for (let i of res.hits) {
            const style = i?.velouAttributes?.styles?.[0];
            if (
              style &&
              i.newSchema.types?.length < 2 &&
              i.newSchema.subCategories?.length < 2
            ) {
              styleCounts[style] = (styleCounts[style] || 0) + 1;
            }
          }
          // Sort styles by frequency
          const sortedStyles = Object.entries(styleCounts)
            .sort((a, b) => b[1] - a[1])
            .map(([style]) => style)
            .slice(0, limit);
          // For each style, pick the item with highest relevance
          for (let style of sortedStyles) {
            const groupItems = res.hits.filter(
              (i) =>
                i?.velouAttributes?.styles?.[0] === style &&
                i.newSchema.types?.length < 2 &&
                i.newSchema.subCategories?.length < 2
            );
            const item = groupItems.reduce(
              (max, curr) =>
                curr.relevance > (max?.relevance ?? -Infinity) ? curr : max,
              null
            );
            if (item) {
              listings.push({
                ...item,
                velouAttributes: {
                  style: style,
                },
              });
            }
          }
          setShowStyles(true);
        }
        if (beforeSearch === window.location.search) {
          setDisplayListings(listings);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setLoading(false);
  };

  const getExtraTwoListingHandler = async (subcategory, type, brand) => {
    setLoading(true);
    await axios
      .post(
        `${process.env.NEXT_PUBLIC_SERVER_API}/api/other/2-listing-discovery`,
        {
          subCategory: subcategory,
          type: type,
        }
      )
      .then((res) => {
        setExtraTwoListings(res.data.listings ? res.data.listings : res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    setLoading(false);
  };
  const [isChange, setIsChange] = useState(false);

  useEffect(() => {
    if (
      category !== undefined ||
      option !== undefined ||
      subType !== undefined ||
      brand !== undefined
    ) {
      setIsChange(true);
    }
  }, [category, option, subType, brand]);

  useEffect(() => {
    if (!isChange) return;

    const isBot = /bot|crawl|slurp|spider|Prerender|facebookexternalhit/i.test(
      navigator?.userAgent
    );
    if (isBot) return;

    let limit;
    const cat = category || "";
    const opt = option || "";
    const typ = subType || "";
    const brn = brand || "";

    const fetchData = () => {
      if (opt !== "" || typ !== "") {
        limit = 4;
        getListingsHandler(cat, opt, typ, brn, limit);
      } else {
        limit = 6;
        getListingsHandler(cat, opt, typ, brn, limit);
      }
      if (opt !== "" || (typ !== "" && !brn)) {
        getExtraTwoListingHandler(opt, typ);
      }
    };

    fetchData();
    setIsChange(false); // Reset isChange after fetching
  }, [
    isChange,
    category,
    option,
    subType,
    brand,
    getListingsHandler,
    getExtraTwoListingHandler,
  ]);

  const capitalizeEachWord = (text) => {
    if (typeof text !== "string") return text;
    const specialCases = {
      "1980_s": "1980s",
      "1990_s": "1990s",
      "20_th_century": "20th Century",
    };
    if (specialCases[text]) {
      return specialCases[text];
    }
    return text
      .replace(/_/g, " ")
      .replace(/-/g, " ")
      .replace(" and ", " & ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const urlForRedirect = (text) => {
    return text?.replace(/ /g, "-").replace(/&/g, "and").toLowerCase();
  };

  const changeHandler = (item) => {
    let urlParams = new URLSearchParams(window.location.search);

    if (style && showStyles) {
      urlParams.set("style", style);
    }
    if (room) {
      urlParams.set("room", room);
    }
    if (locationCity) {
      urlParams.set("location", locationCity);
    }
    if (category) {
      urlParams.set("category", urlForRedirect(category));
    }
    if (option) {
      urlParams.set("option", urlForRedirect(option));
    }

    if (subType) {
      urlParams.set("subType", urlForRedirect(subType));
    }

    const itemStyle = item.velouAttributes?.style;
    if ((itemStyle && subType) || showStyles) {
      urlParams.set("style", itemStyle);
    }

    if (!category && item?.newSchema?.categories) {
      urlParams.set("category", urlForRedirect(item.newSchema.categories[0]));
    }
    if (category && !option && item.newSchema.subCategories) {
      urlParams.set("option", urlForRedirect(item.newSchema.subCategories[0]));
    }
    if (category && option && !subType && item.newSchema.types && !showStyles) {
      urlParams.set("subType", urlForRedirect(item.newSchema.types[0]));
    }

    if (category && option && !subType && item.newSchema.types && showStyles) {
      urlParams.set("option", urlForRedirect(item.newSchema.subCategories[0]));
    }
    urlParams.delete("maxPrice");
    urlParams.delete("minPrice");

    // Construct the new URL path
    const newPath = `/collections?${urlParams.toString()}`;

    // Use history to push the new path
    router.push(`/collections?${urlParams.toString()}`);
  };

  const changeHandlerTwo = (item) => {
    let urlParams = new URLSearchParams(window.location.search);

    if (style) {
      urlParams.set("style", style);
    }
    if (room) {
      urlParams.set("room", room);
    }
    if (locationCity) {
      urlParams.set("location", locationCity);
    }
    if (category) {
      urlParams.set("category", urlForRedirect(category));
    }
    if (option) {
      urlParams.set("option", urlForRedirect(option));
    }

    if (subType) {
      urlParams.set("subType", urlForRedirect(subType));
    }

    if (
      category &&
      option &&
      !subType &&
      item.newSchema.types !== "None" &&
      !showStyles
    ) {
      urlParams.set("subType", urlForRedirect(item.newSchema.types[0]));
    }
    if (item.isPrice) {
      urlParams.set("maxPrice", item.isPrice);
    } else {
      urlParams.delete("maxPrice");
    }
    if (urlParams.get("style")) {
      urlParams.delete("style");
    }
    if (item.isBrand) {
      urlParams.set("brand", urlForRedirect(item.brand));
    } else {
      urlParams.delete("brand");
    }
    const newPath = `/collections?${urlParams.toString()}`;
    router.push(newPath);
  };

  const changeHandlerMore = (url, room) => {
    router.push(`/${url}/${room.url}`);
  };

  const roomsArray = [
    {
      name: "Living Room",
      url: "living_room",

      img: "https://ik.imagekit.io/kuj9zqlrx0or/Static/FurnitureCategories/rooms/living_room2.jpg?tr=w-300",
    },
    {
      name: "Dining Room",
      url: "dining_room",
      img: "https://ik.imagekit.io/kuj9zqlrx0or/Static/FurnitureCategories/rooms/dining_room.jpg?tr=w-300",
    },
    {
      name: "Bedroom",
      url: "bedroom",
      img: "https://ik.imagekit.io/kuj9zqlrx0or/Static/FurnitureCategories/rooms/bedroom.jpg?tr=w-300",
    },
    {
      name: "Office",
      url: "office",
      img: "https://ik.imagekit.io/kuj9zqlrx0or/Static/FurnitureCategories/rooms/office1.jpg?tr=w-300",
    },
    {
      name: "Home Bar",
      url: "home_bar",
      img: "https://ik.imagekit.io/kuj9zqlrx0or/Static/FurnitureCategories/rooms/home_bar.jpg?tr=w-300",
    },
    {
      name: "Small Spaces",
      url: "small_space",
      img: "https://ik.imagekit.io/kuj9zqlrx0or/Static/FurnitureCategories/rooms/small_space1.jpg?tr=w-300",
    },
  ];

  const styleArray = [
    {
      name: "Vintage",
      url: "vintage",
      img: "https://ik.imagekit.io/kuj9zqlrx0or/Static/FurnitureCategories/style/vintage.jpg?tr=w-300",
    },
    {
      name: "Mid-Century Modern",
      url: "mid_century_modern",
      img: "https://ik.imagekit.io/kuj9zqlrx0or/Static/FurnitureCategories/style/mid_century_modern.jpg?tr=w-300",
    },
    {
      name: "Modern",
      url: "modern",
      img: "https://ik.imagekit.io/kuj9zqlrx0or/Static/FurnitureCategories/style/modern.jpg?tr=w-300",
    },
    {
      name: "Hollywood Regency",
      url: "hollywood_regency",
      img: "https://ik.imagekit.io/kuj9zqlrx0or/Static/FurnitureCategories/style/hollywood_regency.jpg?tr=w-300",
    },
    {
      name: "French",
      url: "french",
      img: "https://ik.imagekit.io/kuj9zqlrx0or/Static/FurnitureCategories/style/french.jpg?tr=w-300",
    },
    {
      name: "Industrial",
      url: "industrial",
      img: "https://ik.imagekit.io/kuj9zqlrx0or/Static/FurnitureCategories/style/undustrial.jpg?tr=w-300",
    },
  ];

  const brandsBubbles = useMemo(() => {
    const filteredBrandList = uniqueBrandList.filter(
      (brand) => brand.name && brand.name.trim() !== ""
    );
    const sortedBrandList = filteredBrandList.sort((a, b) => b.count - a.count);

    return sortedBrandList
      .map((brand) => {
        const matchedBrand = brands.find((b) => b.brand === brand.name);
        if (matchedBrand && matchedBrand.link) {
          return {
            name: brand.name,
            url: brand.name
              .replace(/ /g, "-")
              .replace(/&/g, "and")
              .toLowerCase(),
            img: matchedBrand.link,
          };
        }
      })
      .filter(Boolean);
  }, [uniqueBrandList, brands]);

  // Determine if we should show the main category bubbles
  const shouldShowCategoryBubbles = (() => {
    // Destructure subParams for clarity
    const {
      styleParam,
      roomParam,
      locationParam,
      brandParam,
      searchTerm,
      styleBubbles,
      roomBubbles,
      brandBubbles,
    } = subParams;
    // If none are set (current behavior)
    if (
      !styleParam &&
      !roomParam &&
      !locationParam &&
      !brandParam &&
      !searchTerm &&
      !styleBubbles &&
      !roomBubbles &&
      !brandBubbles
    ) {
      return true;
    }
    // If only locationParam is set
    if (
      locationParam &&
      !styleParam &&
      !roomParam &&
      !brandParam &&
      !searchTerm &&
      !styleBubbles &&
      !roomBubbles &&
      !brandBubbles
    ) {
      return true;
    }
    return false;
  })();

  return (
    <>
      <div className={classes.main}>
        <div className={classes.leftSection}>
          <CategoriesContentText
            capitalizeEachWord={capitalizeEachWord}
            brand={brand}
            category={category}
            option={option}
            subType={subType}
            style={style}
            room={room}
            locationCity={locationCity}
            searchTerm={searchTerm}
            sortCriteria={sortCriteria}
          />
          <div className={classes.filterSectionMobile} onClick={handleShow}>
            <Sliders className={classes.filterButton} />
            <div>Filter</div>
          </div>
        </div>
        {shouldShowCategoryBubbles && (
          <section className={classes.rightSection}>
            {loading ||
            (extraTwoListings.length === 0 && displayListings.length === 0) ? (
              <>
                <div className={classes.loadingBox}>
                  <div className={classes.loadingPlaceholder} />
                </div>
                <div className={classes.loadingBox}>
                  <div className={classes.loadingPlaceholder} />
                </div>
                <div className={classes.loadingBox}>
                  <div className={classes.loadingPlaceholder} />
                </div>
                <div className={classes.loadingBox}>
                  <div className={classes.loadingPlaceholder} />
                </div>
                <div className={classes.loadingBox}>
                  <div className={classes.loadingPlaceholder} />
                </div>
              </>
            ) : (
              // Render listings
              <>
                {extraTwoListings &&
                  extraTwoListings.length > 0 &&
                  (option || subType) && (
                    <>
                      {extraTwoListings.map((item, idx) => (
                        <div
                          key={idx}
                          className={classes.item}
                          onClick={() => changeHandlerTwo(item)}
                        >
                          <div className={classes.imgContainer}>
                            <Image
                              width={100}
                              height={100}
                              src={`${item.images[0]}?tr=w-200`}
                              alt={`Example of ${
                                item.isPrice ? (
                                  <>
                                    {option && !subType
                                      ? ` ${
                                          item.newSchema.subCategories[0]
                                        } under $${item.isPrice.toLocaleString(
                                          undefined,
                                          {
                                            maximumFractionDigits: 0,
                                          }
                                        )}`
                                      : subType
                                      ? ` ${
                                          item.newSchema.types[0]
                                        } under $${item.isPrice.toLocaleString(
                                          undefined,
                                          {
                                            maximumFractionDigits: 0,
                                          }
                                        )}`
                                      : ""}
                                  </>
                                ) : (
                                  item.brand +
                                  `${
                                    option && !subType
                                      ? ` ${item.newSchema.subCategories[0]}`
                                      : subType
                                      ? ` ${item.newSchema.types[0]}`
                                      : ""
                                  }`
                                )
                              } `}
                              className={classes.img}
                            />
                          </div>
                          <div className={classes.text}>
                            {item.isPrice ? (
                              <>
                                {option && !subType
                                  ? ` ${
                                      item.newSchema.subCategories[0]
                                    } under $${item.isPrice.toLocaleString(
                                      undefined,
                                      {
                                        maximumFractionDigits: 0,
                                      }
                                    )}`
                                  : subType
                                  ? ` ${
                                      item.newSchema.types[0]
                                    } under $${item.isPrice.toLocaleString(
                                      undefined,
                                      {
                                        maximumFractionDigits: 0,
                                      }
                                    )}`
                                  : ""}
                              </>
                            ) : (
                              item.brand +
                              `${
                                option && !subType
                                  ? ` ${item.newSchema.subCategories[0]}`
                                  : subType
                                  ? ` ${item.newSchema.types[0]}`
                                  : ""
                              }`
                            )}
                          </div>
                        </div>
                      ))}
                    </>
                  )}

                {displayListings && displayListings.length > 0 && (
                  <>
                    {displayListings.map((item, idx) => (
                      <div
                        key={idx}
                        className={classes.item}
                        onClick={() => changeHandler(item)}
                      >
                        <div className={classes.imgContainer}>
                          <Image
                            width={100}
                            height={100}
                            src={`${item.images[0]}?tr=w-200`}
                            alt={`Example of ${
                              !category
                                ? `${item?.newSchema?.categories[0]}`
                                : category && !option
                                ? `${item?.newSchema?.subCategories[0]} `
                                : category && option && !subType && !showStyles
                                ? `${item?.newSchema?.types[0]}`
                                : category && option && (subType || showStyles)
                                ? `${capitalizeEachWord(
                                    item.velouAttributes?.style
                                  )} ${
                                    item.newSchema.types[0]
                                      ? item.newSchema.types[0]
                                      : item.newSchema.subCategories[0]
                                  }`
                                : ""
                            } `}
                            className={classes.img}
                          />
                        </div>
                        <div className={classes.text}>
                          {!category
                            ? `${item?.newSchema?.categories[0]}`
                            : category && !option
                            ? `${item?.newSchema?.subCategories[0]} `
                            : category && option && !subType && !showStyles
                            ? `${item?.newSchema?.types[0]}`
                            : category && option && (subType || showStyles)
                            ? `${capitalizeEachWord(
                                item.velouAttributes?.style
                              )} ${
                                item.newSchema.types[0]
                                  ? item.newSchema.types[0]
                                  : item.newSchema.subCategories[0]
                              }`
                            : ""}
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </>
            )}
          </section>
        )}

        {brandParam && brands && (
          <section className={classes.rightSectionBrand}>
            {brands
              .filter(
                (b) =>
                  b.brand
                    .replace(/ /g, "-")
                    .replace(/&/g, "and")
                    .toLowerCase() === brandParam
              )
              .map(
                (item, idx) =>
                  item.link && (
                    <div className={classes.imgContainerBrand} key={idx}>
                      <Image
                        width={140}
                        height={140}
                        src={`${item.link}`}
                        alt={`Example of ${item.brand}`}
                        className={classes.imgBrand}
                      />
                    </div>
                  )
              )}
          </section>
        )}

        {pathname.split("/").at(1) === "room" && (
          <section className={classes.rightSection}>
            {roomsArray.map((room, idx) => (
              <div
                key={idx}
                className={classes.item}
                onClick={() => changeHandlerMore("room", room)}
              >
                <div className={classes.imgContainer}>
                  <Image
                    width={200}
                    height={200}
                    src={room.img}
                    alt={`Example of ${room.name}`}
                    className={classes.imgContain}
                  />
                </div>
                <div className={classes.text}>{room.name}</div>
              </div>
            ))}
          </section>
        )}
        {pathname.split("/").at(1) === "style" && (
          <section className={classes.rightSection}>
            {styleArray.map((style, idx) => (
              <div
                key={idx}
                className={classes.item}
                onClick={() => changeHandlerMore("style", style)}
              >
                <div className={classes.imgContainer}>
                  <Image
                    width={200}
                    height={200}
                    src={style.img}
                    alt={`Example of ${style.name}`}
                    className={classes.imgContain}
                  />
                </div>
                <div className={classes.text}>{style.name}</div>
              </div>
            ))}
          </section>
        )}
        {pathname === "/brand" && brandsBubbles && (
          <section className={classes.rightSection}>
            {brandsBubbles.slice(0, 6).map((brand, idx) => (
              <div
                key={idx}
                className={classes.item}
                onClick={() => changeHandlerMore("brand", brand)}
              >
                <div className={classes.imgContainerWhite}>
                  <Image
                    width={200}
                    height={200}
                    src={brand.img}
                    alt={`Search for results of ${brand.name}`}
                    className={classes.imgBrand}
                  />
                </div>
                <div className={classes.text}>{brand.name}</div>
              </div>
            ))}
          </section>
        )}
      </div>
    </>
  );
};

export default CategoriesDiscover;
